import React from "react";

export function CardFaturaAguaMobile({ unidadeConsumidora, competencia, vencimento, pagamento, total }) {
    
    const styles = {
        card: {
            width: "100%",
            background: "radial-gradient(circle at top left, rgba(66, 153, 225, 0.22), transparent 35%), linear-gradient(145deg, #081A2D 0%, #0A2740 55%, #0D3552 100%)",
            borderRadius: "18px",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.45), 0 0 25px rgba(66, 153, 225, 0.08)",
            padding: "16px",
            color: "#FFFFFF",
            marginBottom: "15px",
            overflow: "hidden",
        },

        bloco: {
            background: "rgba(26, 54, 93, 0.6)",
            borderRadius: "12px",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            padding: "12px",
            minHeight: "90px",
        },

        grid: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
            marginTop: "10px",
        },

        rodape: {
            background: "linear-gradient(90deg, #2C5282 0%, #4299E1 100%)",
            borderRadius: "12px",
            padding: "12px 15px",
            minHeight: "60px",
            marginTop: "15px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 4px 15px rgba(66,153,225,0.3)",
        },
    };

    return (
        <div style={styles.card}>
            {/* Unidade Consumidora */}
            <div style={styles.bloco}>{unidadeConsumidora}</div>

            {/* Competência */}
            <div style={{...styles.bloco, marginTop: "10px", width: "100%" }}>{competencia}</div>

            {/* Vencimento / Pagamento */}
            <div style={styles.grid}>
                <div style={styles.bloco}>{vencimento}</div>
                <div style={styles.bloco}>{pagamento}</div>
            </div>

            {/* Total */}
            <div style={styles.rodape}>{total}</div>
        </div>
    );
}